import { Component } from '@angular/core';
import { MatDialog, MatDialogRef} from '@angular/material';


// Imports Application
import { DContextoMuisca, DLogger } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DObserverTimerSessionApp } from './configuracion/dformulario-configuracion';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    DContextoUsuarioServicio,
    DNotificacionServicio
  ]
})
export class AppComponent {
  	
  	private datosRespuesta:DContextoMuisca;    
    private nombreUsuario:string;
    private nombreOrganizacion:string;
    private precargaCabecera:boolean = true;
    private tiempo:Date;  

    /**
    * @constructor
    */
    constructor(
        private dialog: MatDialog,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private dNotificacionServicio:DNotificacionServicio,
        private dlogger:DLogger
    ) {  
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();
        observableServicio.subscribe(
            res => {
                this.precargaCabecera = false;
                this.datosRespuesta = <DContextoMuisca>res; 
                this.tiempo = new Date();               
                let tiempoReal = new Date();   
                this.verificarSession();            

                setInterval(()=>{
                    tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
                    this.tiempo = new Date(tiempoReal);                    
                }, 1000);
            }
        );
    }

    /**
    * @desc Función para enviar un log
    */
    public enviarLog() {
        let dialogo = {
            height: '450px',
            disableClose: true
        };     
        let dialogRef = this.dialog.open(DEnvioLogComponente, dialogo);
        dialogRef.afterClosed().subscribe(result => {
            console.log('Dialog result: ', result);
        });    
    }

    /**
    * @desc Función para redireccionar a un link especifico de Muisca
    */
    public hrefButton (href:string, nuevaPagina?: boolean) {
        if (nuevaPagina){
            window.open(location.origin + href, '_blank');
        }
        else{
            window.location.href = location.origin + href;
        }
    }

    /**
    * @desc Función para hacer el logout de la aplicación
    */
    public logoutApp() {
        this.dContextoUsuarioServicio.logOut();
    }

    /**
    * @desc Funcion que verifica un observable para validar la session
    */
    private verificarSession() {
        let observer:DObserverTimerSessionApp = new DObserverTimerSessionApp(this.dNotificacionServicio, this.dContextoUsuarioServicio);
        let ObservableTimer = this.dContextoUsuarioServicio.establecerAccionCierreSesionUsuario(observer);
        ObservableTimer.subscribe(
            respuesta  => {
                this.dlogger.info('Accion establecida con cerrar sesión', respuesta);            
            },              
            error =>{  
                this.dlogger.error('Error estableciendo accion de cierre de sesión', error);
            });
    } 

}



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/app.component.ts